import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class EventTypesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = `/api/eventTypes`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  getEventById(eventTypeId, router){
    const url = `/api/eventTypes/${eventTypeId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = '/api/eventTypes';
    return this.CommonAPIService.postCall(url, params, router);
  }

  // delete(roomId, params, router) {
  //   const url = `/api/eventTypes/${roomId}`;
  //   return this.CommonAPIService.deleteCall(url, params, router);
  // }

  update(eventTypeId, params, router) {
    const url = `/api/eventTypes/${eventTypeId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }
}
export default EventTypesAPIService;
